<template>
  <section class="py-5 bg-white text-dark">
    <div class="container">
      <h1 class="mb-4 text-primary fw-bold">Garanția de participare</h1>

      <p>
        În sprijinul agenților economici participanți la proceduri de achiziție publică, Guvernul României a emis <strong>OUG 136/2022</strong>, care clarifică și eficientizează modalitățile de constituire a garanției de participare. Noile reglementări ajută ofertanții și oferă autorității contractante garanții împotriva comportamentului incorect.
      </p>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-balance-scale me-2"></i>Legea 98/2016 – Art. 154 (modificat prin OUG 136/2022)</h5>
      <p>Garanția de participare sau de bună execuție trebuie să fie <strong>irevocabilă</strong>, <strong>necondiționată</strong> și se poate constitui prin:</p>

      <ul>
        <li><i class="fas fa-university me-2 text-primary"></i>Virament bancar</li>
        <li><i class="fas fa-file-contract me-2 text-primary"></i>Scrisori de garanție:
          <ul>
            <li><i class="fas fa-arrow-right me-2 text-secondary"></i>Emise de instituții bancare (RO sau alt stat)</li>
            <li><i class="fas fa-arrow-right me-2 text-secondary"></i>Emise de instituții financiare nebancare:
              <br />
              <small class="ms-4">– <strong>&le; 40.000.000 lei</strong> (lucrări)</small><br />
              <small class="ms-4">– <strong>&le; 7.000.000 lei</strong> (produse/servicii)</small>
            </li>
            <li><i class="fas fa-arrow-right me-2 text-secondary"></i>Asigurări de garanții de la:
              <ul class="ms-3">
                <li>Societăți autorizate în România sau UE (înregistrate la ASF)</li>
                <li>Societăți din state terțe prin sucursale autorizate în RO</li>
              </ul>
            </li>
          </ul>
        </li>
        <li><i class="fas fa-coins me-2 text-primary"></i>Depunere numerar la casierie (doar dacă <strong>&lt; 5.000 lei</strong>)</li>
        <li><i class="fas fa-hand-holding-usd me-2 text-primary"></i>Rețineri succesive din facturi (doar pentru garanția de bună execuție)</li>
        <li><i class="fas fa-layer-group me-2 text-primary"></i>Combinarea a două sau mai multe dintre metodele de mai sus</li>
      </ul>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-scale-balanced me-2"></i>Legea 101/2016 – Art. 71 (concesiuni)</h5>
      <p>
        Prevederile sunt similare și pentru contractele de <strong>concesiune lucrări/servicii</strong>, conform modificărilor aduse la Art. 71 alin. (6). 
        Modalitățile de constituire a garanției sunt identice:
      </p>
      <ul>
        <li><i class="fas fa-check me-2 text-success"></i>Virament bancar</li>
        <li><i class="fas fa-check me-2 text-success"></i>Scrisori de garanție bancare sau IFN (cu praguri identice)</li>
        <li><i class="fas fa-check me-2 text-success"></i>Asigurări de garanții (societăți autorizate/sucursale ASF)</li>
        <li><i class="fas fa-check me-2 text-success"></i>Numerar la casierie (sub 5.000 lei)</li>
        <li><i class="fas fa-check me-2 text-success"></i>Combinare metode (pentru garanția de bună execuție)</li>
      </ul>

      <p class="mt-4">
        Modificările aduse prin OUG 136/2022 vin în sprijinul ofertanților, simplificând procedura și eliminând ambiguitățile legate de instrumentele acceptate pentru constituirea garanției.
        <br /><br />
        Pentru consultanță specifică în proceduri sau redactarea garanțiilor, ne poți contacta la: 
        <strong><i class="fas fa-envelope me-1"></i>contact@consultantaachizitii.ro</strong>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GarantieParticipare'
}
</script>
